// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// ##### 25-01-22 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
import { changeLang, getPages } from '../../../../Redux/actions';
// ##### 25-05-21 Komarov
import EmailIcon from '../../../Library/Icons/email';
import PhoneIcon from '../../../Library/Icons/phoneicon';
// ##### 23-10-31 Komarov
import { Media } from '../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import DesktopMenuTextItems from './DesktopMenuTextItems';
import MobileMenuTextItems from './MobileMenuTextItems';
// ##### 25-04-30 Komarov
import { uniLog } from '../../../../../server/helpers/uniLog';
import config from '../../../../Redux/config';

// ##### Komarov 2025-07-14
const NavComponent = ({ linkClassName, sitepage_type, sidebarListWidth }) => {
  // ##### 24-03-04 Komarov
  const whiteLabel = useSelector(state => state.whitelabel);
  const isWhiteLabelSet = whiteLabel.set;
  const companyCipher = whiteLabel.company_cipher;

  // ##### 23-05-04 Komarov
  // let lang = useSelector((state) => state.locale.current_locale); // It was const
  let lang = useSelector(state => state.language);
  if (lang === undefined) {
    lang = localStorage.getItem('currentLanguage') || config.defaultLang;
  }
  // ##### Komarov 2025-08-05
  const Mail_icon = useSelector(state => state.pagesRedux[lang]?.Mail_icon || '');
  const Phone_icon = useSelector(state => state.pagesRedux[lang]?.Phone_icon || '');

  const dispatch = useDispatch();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(changeLang());
    // ##### 23-04-12 Komarov
  }, [dispatch]);

  // ##### 24-06-19 Komarov
  const pages = useSelector(state => state.pagesRedux[lang]);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    // ##### 24-03-21 Komarov
    if (pages) {
      return;
    }
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/PageComponents/ResponsiveHeader/NavComponent.js:getPages(lang)'
    );
    dispatch(getPages(lang));
    // ##### 23-04-12 Komarov
  }, [lang, pages, dispatch]);

  // ##### Komarov 2025-07-23
  return (
    <div className={linkClassName} data-component="NavComponentSsr">
      {/* ##### 25-01-16 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        {/* ##### 23-03-31 Komarov */}
        {Mail_icon && <EmailIcon
          key={uniqueId()}
          hintText={
            Mail_icon.includes('No translations for')
              ? 'Email'
              : parse(Mail_icon)
          }
        />}
      </Media>
      {/* ##### 25-01-16 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        {/* ##### 23-10-31 Komarov */}
        {Phone_icon && <PhoneIcon
          key={uniqueId()}
          hintText={
            Phone_icon.includes('No translations for')
              ? 'Phone'
              : parse(Phone_icon)
          }
        />}
      </Media>
      {/* ##### 24-06-19 Komarov */}
      <Media
        greaterThanOrEqual="Laptop-1024-1440"
        // ##### 24-06-21 Komarov
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <DesktopMenuTextItems
          sitepage_type={sitepage_type}
          isWhiteLabelSet={isWhiteLabelSet}
          companyCipher={companyCipher}
        />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <MobileMenuTextItems
          // ##### 24-08-08 Komarov
          sitepage_type={sitepage_type}
          isWhiteLabelSet={isWhiteLabelSet}
          companyCipher={companyCipher}
          sidebarListWidth={sidebarListWidth}
        />
      </Media>
    </div>
  );
};

export default NavComponent;
